<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="
            primary--text
            text-subtitle-2
            text-sm-subtitle-1
            text-md-subtitle-1
            text-lg-subtitle-1
            text-xl-subtitle-1
            font-weight-bold
          "
          >{{ translations.home_menu_label_change_dis }}</span
        >
      </v-card-title>
      <v-card-text class="my-0 py-0">
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="distributor"
                  :items="distributorItems"
                  :label="translations.select_distributor"
                  outlined
                  clearable
                  background-color="white"
                  dense
                  item-text="companyName"
                  return-object
                  :rules="validation(translations.field_required)"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row justify="end" align="end">
            <v-btn
              color="primary"
              @click="show = false"
              text
              class="
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
            >
              {{ translations.cancel }}
            </v-btn>
            <v-btn
              color="primary"
              @click="changeDistributorRequest"
              text
              class="
                text-subtitle-2
                text-sm-subtitle-1
                text-md-subtitle-1
                text-lg-subtitle-1
                text-xl-subtitle-1
              "
            >
              {{ translations.accept }}
            </v-btn>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Validations
import { requiredValidation } from "@/helpers/validations.js";
// Vuex
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    distributor: null,
    distributorItems: [],
  }),
  async created() {
    await this.loadDistrobutors();
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("user", ["FETCH_CLIENTS"]),
    ...mapActions("user", ["getDistributors", "changeDistributor"]),
    validation(value) {
      return requiredValidation(value);
    },
    async changeDistributorRequest() {
      try {
        if (this.$refs.form.validate()) {
          let payload = {
            distributorId: this.distributor._id,
          };
          let response = await this.changeDistributor(payload);
          if (!response) throw response;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: this.translations.label_distributor_change_successful,
            timeout: 4000,
          });
          this.FETCH_CLIENTS(true);
          localStorage.setItem(
            "distributionOrganizationId",
            this.distributor._id
          );
          localStorage.setItem("companyDistributorName", response.companyName);
          this.$emit("updateData");
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    async loadDistrobutors() {
      try {
        let payload = {};
        let response = await this.getDistributors(payload);
        if (!response) throw response;
        this.distributorItems = response.distributors;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
  },
};
</script>

<style scoped></style>
